import Vue from 'vue';

import { END_POINTS } from '@/enums';

import API from './index';

const END_POINT = END_POINTS.ORDERS;

export default {
  async checkStatus(orderGuid: string): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/${orderGuid}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/checkStatus`, err.response);
      throw err.response;
    }
  },
  async sendArrivalNotification(
    orderGuid: string,
    message: string | null,
  ): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/${orderGuid}/arrival`, { message: message })).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/addProduct`, err.response);
      throw err.response;
    }
  }
}
